import React, {Fragment, useState} from 'react';
import {Button, Form, message, Modal} from "antd";
import {ReloadOutlined} from "@ant-design/icons";
import Search from "antd/es/input/Search";
import {useTranslation} from "react-i18next";
import {getRequest} from "../../api/config";
import {replaceAll} from "../component";
import {roaming_document_by_id} from "../../api/api";

const SyncRoamingDocument = () => {
    const {t} = useTranslation();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const [form] = Form.useForm();

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
    };

    const onSubmit = async ({id}) => {
        setLoading(true);
        try {
            await getRequest({
                url: replaceAll(roaming_document_by_id, {id}),
                params: {
                    sync: true
                }
            });
            message?.open({
                content: t('successfully'),
                key: 'updatable',
                type: 'success'
            })
            handleCancel();
        } catch (error) {
            message?.open({
                content: error?.message,
                key: 'updatable',
                type: 'error'
            })
        } finally {
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <Button
                onClick={showModal}
                color="primary"
                variant="solid"
                icon={<ReloadOutlined />}
                size={"large"}
                loading={loading}
            >
                {t('sync_roaming_document')}
            </Button>
            <Modal
                title={t('sync_roaming_document')}
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
            >
                <Form
                    layout={'vertical'}
                    form={form}
                    onFinish={onSubmit}
                >
                    <Form.Item
                        name={'id'}
                    >
                        <Search
                            allowClear
                            enterButton={t('load')}
                            size="large"
                            onSearch={() => form.submit()}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </Fragment>
    );
};

export default SyncRoamingDocument;